import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Text, UnstyledButton, Group, ThemeIcon } from '@mantine/core';

export default function Nav({ links }) {
  return (
    <React.Fragment>
      {links.map((link, index) => (
        <CustomLink
          key={index}
          to={link.to}
          text={link.text}
          icon={link.icon}
          color={link.color}
        />
      ))}
    </React.Fragment>
  );
}

export function CustomLink({ to, color, icon, text }) {
  const location = useLocation();
  const isActive =
    to === '/'
      ? location.pathname === '/' || location.pathname.startsWith('/athletes')
      : location.pathname === to || location.pathname.startsWith(`${to}/`);

  return (
    <UnstyledButton
      component={Link}
      to={to}
      style={{
        display: 'block',
        width: '100%',
        padding: 'var(--mantine-spacing-xs)',
        backgroundColor: isActive ? 'rgba(239,239,236,.35)' : 'transparent',
        borderRadius: 'var(--mantine-radius-sm)',
      }}
    >
      <Group>
        <ThemeIcon radius="xl" size="sm" variant="light" color={color}>
          {icon}
        </ThemeIcon>
        <Text size="sm">{text}</Text>
      </Group>
    </UnstyledButton>
  );
}
